import { graphql, useStaticQuery } from "gatsby";
export const useHeroContentQuery = () => {
    const data = useStaticQuery(graphql`
    query {
        contentfulPage(slug: {eq: "/"}) {
              title
              heroHeading
              heroSubHeading
              heroImage {
                file {
                  url
                }
              }
            }
          }
    `);
    return data;
}